export const CLASS_NAME = 'cst-input'
